import React from "react";
import { Button } from "@/components";
import { EmptyHistory } from "@/pages/Profile/components/EmptyHistory";
import { HistoryDateSection } from "../HistoryDateSection";
import { YearSeparator } from "@/components/YearSeparator";
import { HistoryEntry } from "../../History";
import styles from "./HistoryContent.module.scss";

interface HistoryContentProps {
  entries: HistoryEntry[];
  hasMore: boolean;
  onLoadMore: () => void;
}

export const HistoryContent: React.FC<HistoryContentProps> = ({
  entries,
  hasMore,
  onLoadMore,
}) => {
  if (entries.length === 0) {
    return <EmptyHistory />;
  }

  return (
    <div className={styles.tabContent}>
      {entries.map((entry, idx) => {
        if (entry.type === 'year') {
          return <YearSeparator key={`year-${entry.year}`} year={entry.year} />;
        }
        return (
          <HistoryDateSection
            key={`date-${entry.dateKey}-${idx}`}
            date={entry.dateKey}
            items={entry.items}
          />
        );
      })}
      {hasMore && (
        <Button
          newStyles={styles.loadMoreButton}
          onClickFunc={onLoadMore}
        >
          Показать ещё
        </Button>
      )}
    </div>
  );
};
